import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { PaymentRequest } from '../stripe/models/payments.models';
import { SharedService } from '../_shared/shared.service';

@Injectable({
	providedIn: 'root',
})
export class PaymentsService extends SharedService {
	constructor(http: HttpClient) {
		super(http);
	}

	createTransactionWithPaymentRequest(request: PaymentRequest) {
		return this._http.post<any>(`${this.api}/transactions/request`, request);
	}

	getRequestWithTransactionId(id: string) {
		return this._http.get<any>(`${this.api}/transactions/request/${id}`);
	}

	postPayment(data: any) {
		return this._http.post<any>(`${this.api}/transactions/post/stripe`, data);
	}

	requestLog(href: string, transactionId: string): any {
		return this._http.post<any>(`${this.api}/transactions/log`, {href, transactionId});
	}

	getStateCodeArray() {
		return ['AL', 'AK', 'AR', 'AZ', 'CA', 'CO', 'CT',
		'DC', 'DE', 'FL', 'GA', 'HI', 'IA', 'ID', 'IL', 'IN', 'KS', 'KY',
		'LA', 'MA', 'MD', 'ME', 'MI', 'MN', 'MO', 'MS', 'MT', 'NC', 'NE',
		'NH', 'NJ', 'NM', 'NV', 'NY', 'ND', 'OH', 'OK', 'OR', 'PA', 'RI',
		'SC', 'SD', 'TN', 'TX', 'UT', 'VT', 'VA', 'WA', 'WI', 'WV', 'WY'];
	}
}
